import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/* A new screen opens at its TOP.

   ★★ **Nothing in a single-page app does this for you.** A browser scrolls a new DOCUMENT to the
   top; a router that swaps components under the same document does not, so the scroll offset of
   the screen you left is the offset the next one opens at. That is invisible on short screens and
   ruinous on long ones: the run sheet is opened from a button two thousand pixels down the
   competition cockpit, so it opened two thousand pixels down — past its own back arrow, past the
   card that says what is being played, and (on a shorter page, where the browser clamps the offset
   to what is left) at the very bottom. The screen looked like it was missing half of itself and
   had no way back, when in truth nothing was missing and nobody had been taken to it.

   ★ Only on PUSH and REPLACE — never on POP. Going BACK must land where you were reading, and the
   browser already restores that for same-document history entries; scrolling to the top there
   would undo the one piece of scrolling the visitor actually wants kept.

   ★ On the PATH, not on the query string. A screen that puts a tab or a filter in the URL rewrites
   its own address all day long, and jumping to the top on every one of those would be a tic.
   ``usePersistUrlParams`` rewrites it too, for every link that carries parameters.

   ★ A link with a #fragment is asking for a place on the page. Leave it alone. */
const useScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP' || hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);
};

export default useScrollToTop;
